(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/fraction-payment/assets/javascripts/fraction-payment-actions.js') >= 0) return;  svs.modules.push('/components/marketplace-data/fraction-payment/assets/javascripts/fraction-payment-actions.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk;
const QS_FRACTION_DATA = svs.components.marketplaceShared.sharedConstants.constants.QS_FRACTION_DATA;

const payFraction = createAsyncThunk('payFraction', async _ref => {
  let userContextCallback = _ref.userContextCallback,
    fractionData = _ref.fractionData,
    trackingData = _ref.trackingData,
    memberId = _ref.memberId;
  const activatedDrawId = fractionData.activatedDrawId,
    containerId = fractionData.containerId,
    groupId = fractionData.groupId,
    fractionPrice = fractionData.fractionPrice,
    productId = fractionData.productId,
    _fractionData$numberO = fractionData.numberOfShares,
    numberOfShares = _fractionData$numberO === void 0 ? 1 : _fractionData$numberO;
  const fraction = svs.components.payment.createFraction.createFraction().setActivatedDrawId(activatedDrawId).setContainerId(containerId).setGroupId(groupId).setFractionPrice(fractionPrice).setPrice(fractionPrice * numberOfShares).setProductId(productId).setCount(numberOfShares);
  const paymentBuilder = svs.components.wagerPaymentFlow.fractionFlow.createFractionPaymentFlow({
    config: {
      haltPaymentOnException: true
    },
    fraction
  });
  const _await$svs$components = await svs.components.wagerPaymentFlow.executePayment.executePayment(paymentBuilder, {
      userContext: {
        trackingData,
        returnQuery: {
          ["".concat(QS_FRACTION_DATA)]: "".concat(activatedDrawId, "_").concat(groupId)
        },
        callback: userContextCallback
      }
    }),
    _await$svs$components2 = _slicedToArray(_await$svs$components, 2),
    error = _await$svs$components2[1];
  if (error) {
    throw error;
  }
  return {
    memberId,
    groupId,
    fractionsBought: 1,
    activatedDrawId
  };
});
setGlobal('svs.components.marketplaceData.fractionPayment.actions', {
  payFraction
});

 })(window);